import { motion } from "framer-motion";

export const EASE = [0.25, 0.6, 0.3, 1];

export function Reveal({ children, delay = 0, y = 12, className = "" }) {
  return (
    <motion.div
      className={className}
      initial={{ opacity: 0, y }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, amount: 0.15 }}
      transition={{ duration: 0.5, delay, ease: EASE }}
    >
      {children}
    </motion.div>
  );
}
